import { Store } from 'pullstate'

import getPagesStoreInit from '../StoresFunctions/getPagesStoreInit'

const init = getPagesStoreInit();

const PagesStore = new Store(init);

export default PagesStore;